<template>
  <div class="container mb-4">
    <div class="row mt-4">
      <div class="col">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <router-link to="/statistics/brands" :class="`nav-link ${active == 'brands' ? 'active' : ''}`">
              Brands & models
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/statistics/markets-and-consumers" :class="`nav-link ${active == 'markets-and-consumers' ? 'active' : ''}`">
              Markets & Consumers
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/statistics/devices" :class="`nav-link ${active == 'devices' ? 'active' : ''}`">
              Devices
            </router-link>
          </li>
        </ul>
        <div class="tab-content">
          <router-view />
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>

export default {
  computed: {
    active() {
      return this.$route.name;
    }
    
  }
};
</script>
